var map = {
	"./q0.png": "182c",
	"./q1.png": "bacd",
	"./q2.png": "243d",
	"./q3.png": "edfa",
	"./q4.png": "983c",
	"./q5.png": "e4b0",
	"./q6.png": "c56d",
	"./target.png": "f127"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0ee6d";